import { DefaultTheme, StyledComponent } from 'styled-components';

export enum AnalyticsTabs {
  OVERVIEW = 'overview',
  CAMPAIGNS = 'campaigns',
}

export type TabType = {
  id: AnalyticsTabs;
  label: string;
};

export type SectionType = {
  SectionWrapper: StyledComponent<'div', DefaultTheme>;
  SectionComponent: (props: TabSectionPropType) => JSX.Element;
};

export type OverviewSectionType = SectionType & {
  section: OverviewTabSection;
};

export type CampaignSectionType = SectionType & {
  section: CampaignTabSection;
};

export enum OverviewTabSection {
  CAMPAIGN_PERFORMANCE = 'performantCampaigns',
  COMPLETION_VS_SENDS = 'completionsVsSendsMetrics',
  GOAL_CONTRIBUTIONS_BY_MEDIUM = 'goalContributionsByMediumMetrics',
  GOAL_PERFORMANCE = 'goalPerformance',
}

export enum CampaignTabSection {
  CAMPAIGN_CONTRIBUTION = 'campaignContribution',
}

export type TabSections = OverviewTabSection | CampaignTabSection;

export type SectionStateType = {
  loading: boolean;
  error: boolean;
};

export type TabSectionType<T extends TabSections> = { [key in T]?: SectionStateType };

export interface TabContextState {
  selectedTab: AnalyticsTabs;
  setSelectedTab: (tab: AnalyticsTabs) => void;
  sections: TabSectionType<TabSections>;
  setErrorState: (key: TabSections, value: boolean) => void;
  setLoadingState: (key: TabSections, value: boolean) => void;
  loadAllSections: () => void;
}

export type TabSectionPropType = SectionStateType & {
  isIterableGoalsStretchFlagOn: boolean;
  currentTab: AnalyticsTabs;
  section: TabSections;
  startTime?: string;
  endTime?: string;
  goalName?: string;
  setErrorState: (value: boolean) => void;
  setLoadingState: (value: boolean) => void;
  reFetchGoalAnalyticsData?: () => void;
};
